import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ChannelModel extends ModeModelBase {
  channelName: string;

  override _name = 'channel';
  override initialize(resource) {
    this.channelName = '#' + resource.name;
  }
  override belongsTo = 'slackApp';
  override parentIdAttribute = 'id';
  override attributes = [
    { name: 'id', default: '' },
    { name: 'channel_id', default: '' },
    { name: 'name', default: '' },
    { name: 'created', default: '' },
    { name: 'topic', default: '' },
    { name: 'purpose', default: '' },
    { name: 'num_members', default: '' },
  ];
}

@Injectable({ providedIn: 'root' })
export class ChannelModelAccessor extends ModelAccessorBase<ChannelModel> {
  override name = 'channel';
  override parentModel = 'slackApp';
  override parentIdAttribute = 'id';
  createModel(resource, opts?) {
    const model = new ChannelModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.channel');
  }
}
